"use client";

import { FormEvent, useState, useTransition } from "react";

type LeadType = "email" | "number";

export function HeroLeadForms() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isPending, startTransition] = useTransition();

  function submitLead(type: LeadType, value: string) {
    if (!value.trim()) {
      return;
    }

    setError("");
    setIsSubmitted(true);

    startTransition(async () => {
      const endpoint = type === "email" ? "/api/quick/email" : "/api/quick/number";
      const payload = type === "email" ? { EmailAddress: value } : { Number: value };

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        setError("Unable to connect to service");
      }
    });
  }

  function handleEmailSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    submitLead("email", String(data.get("email") ?? ""));
  }

  function handleNumberSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    submitLead("number", String(data.get("phone") ?? ""));
  }

  if (isSubmitted) {
    return (
      <div className="lead-thank-you" role="status">
        <strong>Thank you.</strong>
        <span>One of our media monitoring specialists will be in touch shortly.</span>
        {error ? <small>{error}</small> : null}
      </div>
    );
  }

  return (
    <div className="hero-actions" aria-label="Lead capture options">
      <form className="lead-form" onSubmit={handleEmailSubmit}>
        <input type="email" name="email" placeholder="Email Address" aria-label="Email Address" required />
        <button className="button" type="submit" disabled={isPending}>
          Start Now
        </button>
      </form>
      <span className="form-separator">or</span>
      <form className="lead-form" onSubmit={handleNumberSubmit}>
        <input type="tel" name="phone" placeholder="Contact Number" aria-label="Contact Number" required />
        <button className="button" type="submit" disabled={isPending}>
          Start Now
        </button>
      </form>
    </div>
  );
}
